// extracted by mini-css-extract-plugin
module.exports = {"statistics":"Statistics_statistics__2lp5v","statistic-tile":"Statistics_statistic-tile__Me9Cw"};